import { ICommand, IQuery } from 'core-ts-types';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { AdvisorHeaderDetailsQuery } from '../../../suggestions/components/plan_feedback/queries/advisor_plan_details_query';

class AdvisorHeaderViewPlan {
  private name: string;
  private createdDate: string;
  private showRevokeDialog: boolean = false;
  private disableRevoke: boolean = false;

  constructor(
    private ngAPStudentDetailsQuery: IQuery,
    private createEmptySuggestedPlanCommand: ICommand,
    private changeSuggestedPlanStatusCommand: ICommand,
    private $state: ng.ui.IStateService,
    private ngAPNotificationDelegate: INotificationDelegate,
    private navigateIfPlanBlockedCommand: ICommand,
    private ngAPAdvisorHeaderDetailsQuery: AdvisorHeaderDetailsQuery
  ) {}

  initialize() {
    this.name = this.ngAPStudentDetailsQuery.result.first_name;
    this.disableRevoke = this.ngAPAdvisorHeaderDetailsQuery.result.disableRevoke;
  }

  $onInit() {
    this.initialize();
  }

  toggleRevokeDialog(openTheRevokePopup: boolean) {
    if (!openTheRevokePopup) {
      this.showRevokeDialog = false;
      return;
    }
    const sendPlanAlertName = 'check-plan-status-alert-name';
    this.ngAPNotificationDelegate.info({ content: 'Checking the status of the plan...', name: sendPlanAlertName });

    this.navigateIfPlanBlockedCommand()
      .then(() => {
        this.showRevokeDialog = true;
      })
      .finally(() => this.ngAPNotificationDelegate.dismissAlertByName(sendPlanAlertName));
  }

  revokePopupOpenedChanged($event: any) {
    if (!$event.detail.value) {
      this.showRevokeDialog = false;
    }
  }

  revokePlan() {
    this.toggleRevokeDialog(false);
    this.changeSuggestedPlanStatusCommand('EDITING')
      .then(() => {
        this.$state.go('ap-advisor.plan.edit.default');
        this.ngAPNotificationDelegate.success('Successfully revoked your suggestions.');
      })
      .catch((error) => {
        if (error.status === 400) {
          this.disableRevoke = true;
        }
        this.$state.go('ap-advisor.plan.view.default');
        this.ngAPNotificationDelegate.error(
          'Unable to revoke current suggestions as student has started acting on it.'
        );
      });
  }
  async createEmptySuggestion() {
    await this.createEmptySuggestedPlanCommand();
    this.$state.go('ap-advisor.plan.edit.default');
  }
}

angular.module('capability-ng-academic-planner').component('advisorHeaderViewPlan', {
  templateUrl: 'capability-ng-academic-planner/src/advisor_header/components/view_plan/view_plan.html',
  controller: AdvisorHeaderViewPlan
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/view_plan/view_plan.ts